export default "__VITE_ASSET__7bff3aef__"